import { useMutation } from '@tanstack/react-query';
import fetchResyncData from '@data/selloutMonitoring/fetchResyncData';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { useResyncModal } from '@pages/SelloutMonitoring/hooks/state/resyncModal';

const useResyncData = (queries) => {
    const { setResyncModal } = useResyncModal();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const showSnackbar = (config) =>
        onChangeSnackbarNotification({
            duration: 3,
            alwaysShow: false,
            ...config,
        });

    return useMutation({
        mutationFn: () => fetchResyncData(queries),
        onMutate: () => {
            showSnackbar({
                title: 'Proses Resync Data Sellout',
                description: 'Silahkan menunggu, sedang dalam proses pembaruan data',
                status: 'info',
                duration: 2,
            });
        },
        onSuccess: (data) => {
            if (data?.detail.length === 0) {
                return showSnackbar({
                    title: 'Sukses Resync Data Sellout',
                    description: 'Data sellout berhasil diperbarui',
                    status: 'success',
                });
            }

            setResyncModal({
                isOpen: true,
                resyncData: data,
            });
        },
        onError: (error) => {
            const fallbackError = !error?.response?.data;

            if (fallbackError) {
                return showSnackbar({
                    title: 'Gagal Resync Data Sellout',
                    description: 'Terjadi gangguan pada saat proses resync data sellout',
                    status: 'error',
                });
            }

            setResyncModal({
                isOpen: true,
                resyncData: error?.response?.data,
            });
        },
    });
};

export default useResyncData;
